import { mdiLock } from '@mdi/js'
import Icon from '@mdi/react'
import type { IconProps } from '.'

const Lock = (props: IconProps) => {
    const { filled, color, size = 1, title, ...other } = props
    return (
        <Icon
            data-testid="IconButton__Lock"
            path={mdiLock}
            title={title}
            size={size}
            color={color}
            {...other}
        />
    )
}

export default Lock
